class CollectionFilterDropdown extends HHBaseElement {
  loading = false

  constructor() {
    super()
    this.$toggle = this.querySelector('[data-toggle]')
    this.dropdownContainer = this.querySelector('.collection-filters__list-item__dropdown')

    this._handleToggle = this._handleToggle.bind(this)
    this.close = this.close.bind(this)
    this._handleDocumentClick = this._handleDocumentClick.bind(this)
    this._handleMouseLeave = this._handleMouseLeave.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  static get observedAttributes() {
    return ['open']
  }

  get isAccordionMode() {
    return this.hasAttribute('accordion')
  }

  get isOpen() {
    return this.hasAttribute('open')
  }

  _attachListeners() {
    this.$toggle.addEventListener('click', this._handleToggle)
    if (!this.isAccordionMode) {
      // this.addEventListener('change', this.close)
      document.addEventListener('click', this._handleDocumentClick)
      this.dropdownContainer.addEventListener('mouseleave', this._handleMouseLeave)
    }
  }

  _removeListeners() {
    this.removeEventListener('change', this.close)
    this.$toggle.removeEventListener('click', this._handleToggle)
    document.removeEventListener('click', this._handleDocumentClick)
    this.dropdownContainer.removeEventListener('mouseleave', this._handleMouseLeave)
  }

  close() {
    this.removeAttribute('open')
    this.$toggle.setAttribute('aria-expanded', 'false')
  }

  open() {
    this.setAttribute('open', '')
    this.$toggle.setAttribute('aria-expanded', 'true')
  }

  _handleToggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  _handleDocumentClick(event) {
    if (this.isOpen && !this.contains(event.target)) {
      this.close()
    }
  }

  _handleMouseLeave(event) {
    if (this.isOpen) {
      this.close()
    }
  }
}

window.customElements.define(
  'collection-filter-dropdown',
  CollectionFilterDropdown
)
